module.exports = __webpack_public_path__ + "img/next-arrow-grey.3c599a1e.svg";